var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.18 336.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#812990;}.cls-3{fill:#6b7b84;}.cls-4{fill:#231f20;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-5{stroke:#fbb040;}.cls-6{stroke:#6b7b84;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 497.6,
    y1: 295.18,
    x2: 555.01,
    y2: 295.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "555.01 319.09 526.3 271.26 497.61 319.09 555.01 319.09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.59,300.9l-.65.09a1.71,1.71,0,0,1-.32.07c-.24,0-.37-.31-.72-.38-.08,0,0,0-.13,0s0,0-.16-.08c0,.23,0,.16,0,.34a1.42,1.42,0,0,0,.14.59c.07.12.09.08.09.27a1.12,1.12,0,0,0,.1.73,2.08,2.08,0,0,1,.25.52c.34,0,.29,0,.34.1.32,0,.11-.07.29-.1,0,0,.32.08.24-.33.24.07.13.19.28.18s.07-.12.09-.27-.07,0,.16-.15l0-.29c0-.34.08,0,.19.05l.14-1c0-.08.11,0-.09-.33C55.51,300.88,55.64,300.88,55.59,300.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.68,300c0,.13.08.07-.09.09l.19.43a.27.27,0,0,1,.19,0c0-.3,0-.19-.1-.34S55.81,300.06,55.68,300Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.27,299.65c-.05.19,0,0-.06.15s-.09.43.2.28C53.41,299.74,53.45,299.77,53.27,299.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.55,296.23a1.7,1.7,0,0,0-.59.09c-.35.09-.2.17-.09.34a2.23,2.23,0,0,0,.84-.12c.16,0,.17,0,.08-.17h-.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.32,293.86a.94.94,0,0,0,0-.16l-.55-.21c-.4-.14-.79-.29-1.17-.44s-.79-.32-1.23-.54a16,16,0,0,1-1.42-.78,3.18,3.18,0,0,1-1.17-1.33,3.74,3.74,0,0,1-.27-.67h-.09a2.34,2.34,0,0,0-.53.07l-.5.13a6.22,6.22,0,0,1-1.35.25h-.17l-.51,0a2.42,2.42,0,0,1-.39,0c-.28,0-.55-.09-.8-.14l-.29-.06c-.07.08-.14.17-.22.25a.67.67,0,0,1,.15.14,1,1,0,0,1,.2.95,1.44,1.44,0,0,1-1.26.92l-.46,0h-.08a1.55,1.55,0,0,1-1.24-.81,1.12,1.12,0,0,1,.09-1.21l0,0,.2-.3a2.84,2.84,0,0,0,.22-.35c.05-.09.09-.17.13-.26a1.64,1.64,0,0,1-1.39-1.05,3.29,3.29,0,0,1-.22-1l-.14,0-.22.06-.19.21a1.25,1.25,0,0,1-.86.4,1.06,1.06,0,0,1-.34-.06h-.05a1.1,1.1,0,0,1-.64-.2.78.78,0,0,1-.36-.26.81.81,0,0,1-.17-.71,3,3,0,0,1,.56-1.2l.06-.09a1.22,1.22,0,0,1,.34-.69,5.34,5.34,0,0,1,.44-.39l.11-.1.24-.19a1.47,1.47,0,0,1,.24-.64,2.67,2.67,0,0,1,.79-.78l.5-.28.24-.14.22-.14.13-.08a.75.75,0,0,1,.38-.1.78.78,0,0,1,.31.06.77.77,0,0,1,.42.88l-.24.84a1.9,1.9,0,0,1-.36.67,4.31,4.31,0,0,1,.52.35,4,4,0,0,1,.42.39h.31l.11,0a2.68,2.68,0,0,0,.76-.35l.11-.06a6.72,6.72,0,0,1,1.5-.72,9.94,9.94,0,0,1,2.67-.37h.35c.5,0,1,0,1.45.05a9,9,0,0,1,1.11.15,6.63,6.63,0,0,1,2.67,1.16.51.51,0,0,0-.26-.37c-.14-.06-.07,0-.17-.09l0,0-.11-.08c-.17-.11-.14,0-.21-.23l-.06,0h0c-.11,0-.07-.19-.17-.31s0,.1-.2,0,0,0-.08-.06a.23.23,0,0,0-.1-.05l-.09,0c-.4-.16-.32-.23-.32-.63-.35-.09-.14-.35-.12-.57s-.17-.4-.08-.78c-.48,0-.29-.47-.42-1l0-.47c0-.1,0,0,0-.14l-.12-.06c-.46-.27-.37-.48-.5-.56l-.33.1c-.1.07,0,.05-.15.09-.32-.3-.17-.92-.28-1.32,0-.17-.08-.4-.31-.46a.72.72,0,0,1,.15-.29c-.12-.06-.17,0-.29-.1a1.4,1.4,0,0,0-.15-.77c-.09-.16,0-.17-.24-.19-.06.23,0,.09-.24.19a1.36,1.36,0,0,1-.18.74v0l0,.06a.9.9,0,0,0-.2.47h.14c0,.22,0,.09-.11.23s0,0,0,.24-.17.27-.14.54.07.12.07.29,0,.14,0,.27c0,.36.15.27,0,.62s-.11.71-.33,1.07-.19.42-.25.52a.69.69,0,0,1-.54.21,1.85,1.85,0,0,1-.49-.24c-.09,0-.17-.08-.21-.17s0-.06-.05-.14c-.12-.24-.44-.22-.66-.3s-.32-.41-.87-.63l-.29-.1-.23-.15-.18-.21c-.06-.05-.16-.1-.23-.16l-.21-.13c-.19-.1-.16,0-.17-.27.11,0,.23-.23.32-.36s0,0,.06-.08l0-.11s0,0,0,0a2.44,2.44,0,0,1,.1-.24c-.2-.07,0,0-.2-.05.08-.11.06,0,.1-.19.25-.12.19,0,.34,0,.29-.42.12-.15.18-.4s.2-.25.3-.41l-.18-.11c-.2-.11-.15.07-.15-.28a.89.89,0,0,0-.39.29c-.05-.06-.05.1-.05-.14a.81.81,0,0,1-.25.09c.15-.18.08,0,.15-.19a1.26,1.26,0,0,0-.63.24c-.12-.08-.19-.08-.24-.24-.24,0-.06,0-.28.1a1,1,0,0,0-.39-.2v-.09c-.26,0-.43.16-.65-.09l-.13-.2c-.18.05-.1.05-.24.14a.4.4,0,0,0-.21-.27c-.08-.05,0,0-.1,0l-.27,0s.07,0-.14,0v.15c.18,0,0,0,.13.05l0,0h0c.14.06.15,0,.38,0a1.12,1.12,0,0,1,.09.44l-.35.12h0l-.44,0c-.18,0-.12,0-.19-.18l-.12.06-.13.07c-.14.11.08,0-.16.13-.08,0-.12,0-.22,0s0,.12-.11.28,0,.14-.23.16c0,.35,0,.15.1.38l-.16.06c-.24.06-.12.06-.21.3s-.21.07-.3.51c.15.11.19.11.22.21a.55.55,0,0,1,0,.18c-.46,0-.26,0-.43,0a1.8,1.8,0,0,0-.54-.08c0,.35,0,.11-.1.2l0,0-.07.12c0-.34.07-.1.09-.39-.4-.11-.39-.54-.8-.61s0-.1-.36-.11c-.08.18,0,.21-.19.33.05-.22,0-.07,0-.14s-.1.05-.24.14c0-.21-.06-.18-.24-.09,0,.14,0,.1.14.14a.76.76,0,0,0-.1.29l-.28-.24c-.13.25,0,.17-.19.3l-.06,0a.61.61,0,0,0-.14.1c.07.26.13,0,0,.24-.17,0-.18.07-.29.21l0,0,0,0-.08.07c-.07.07-.15.09-.18.24a.43.43,0,0,0,.13.28c-.11.13-.1.08-.1.29l-.22-.07c-.22,0-.1.12-.17-.07H39c0,.32-.12.24-.05.39s.18.12.29.28c-.12.05,0,0-.19,0,0,.25.06.08,0,.34-.15-.11-.07-.08-.24-.39s-.18-.11-.15-.43c-.2.05-.18.15-.28.29l-.24.25a.85.85,0,0,0-.19.38c0,.14.09.22.09.47,0,0,0,0,0,0l.13,0c0,.11,0,.06-.07.13l-.05,0c-.07.08,0,0-.07.07l-.08.06,0,0-.06.05c-.12.1-.09.11-.15.24l0,.06c-.29.77-.47.77-1.32,1.09-.17.06,0,0-.18.05s-.13-.11-.33,0,0,.11-.19.24-.28-.08-.73.38a.39.39,0,0,1-.3.12c-.25,0-.06-.14-.38.08,0-.26,0-.1-.1-.15,0,.15,0,.12-.16.22-.29.22-.06-.06-.47.4l0,0-.15.18s0,.05-.05.06c-.22.25-.71.15-.71.92h-.14a2.58,2.58,0,0,1,0-.53,1.12,1.12,0,0,0-.35.86c.16.06.05-.08.13.12a.66.66,0,0,1,0,.6.93.93,0,0,0-.1.26v.35c0,.11.05.07.16.21s0,.17.25.42l0,0,.12.17c.19.25.27.12.27.7h-.1a.77.77,0,0,0-.53-.63c0,.44.12.15.15.48-.12-.07,0-.06-.2-.09,0,.24.05.08-.1.14.32.46.81.64.93,1.24,0,.27.33.41.43.64s0,0,.08.15l.15.15a.64.64,0,0,1,.16.41c.16,1,.78,1.23.85,1.84v.36c0,.22,0,.18.08.39s0,.29-.07.45a1.11,1.11,0,0,1-.28,0c0,.34,0,.66.29.65s.55.5,1.22.39c.2,0,.55,0,.74-.1s.21-.22.28-.3l0,0,.07-.08,0,0,.15-.08c.11,0,.29,0,.34-.17v-.09c.08-.27.46-.27.71-.35l.55-.08h.11c.18,0,0,0,.13,0l.07,0h0c.17.08-.13.05.17.07,0-.11.1-.16.41-.16s.56.15.71-.5a.6.6,0,0,1,.1-.25c.12-.14.2-.08.39-.19.76-.44.47-.52,1.34-.54a2.41,2.41,0,0,0,.92-.28c.57-.23.51-.39,1.39-.39a2,2,0,0,0,.56-.08c.21,0,.64.31.8.41.28-.07.13-.19.47,0s.35.08.59.13c.06.15,0,0,0,.24.15,0,.15-.06.29,0-.05.11-.09.07-.12.18l.1.28c.12.1.21,0,.33.14a3.73,3.73,0,0,0,.26.43.8.8,0,0,1,.15.47h-.07l-.12.13c.29,0,.21.21.48.27l.09,0a.24.24,0,0,0,.1,0l0-.19c0-.15,0-.19.28-.53s.51-.22.65-.47a1.26,1.26,0,0,1,.21-.36c.12-.13,0,.05.11-.14l0,0,0,.06.08.11c-.14,0-.12,0-.19.1.1.22.1.19,0,.32a1.15,1.15,0,0,0-.24.76c0,.28-.06.22-.33.22,0,.18-.08.13-.1.34a1.56,1.56,0,0,0,.34-.1c.2-.05.22.11.34-.14l.19-.58.09.15,0,0,0,.07,0,0c.27.55-.18.56-.21.88a1.57,1.57,0,0,0,.48-.09l0,0,0,0c.3.26.62.59.48,1v0l0,.24a.85.85,0,0,0,.21.3l.2.33c.15.16.37.09.54.28l.13.15c.14-.05.14-.1.29-.06l.11,0,0,0c.13,0,.06,0,.19.05s.49.28.53.39c.27,0,.79-.69.91-.2.24,0,.25-.16.44-.19l0,.07c-.07.14,0-.09-.07.17l.23.21.07.07.15.06a.37.37,0,0,1,.09.2.24.24,0,0,0,.14-.34c.57,0,.73-.57,1.33-.55.39,0,.7.14,1-.09l.1-.14c.07-.17,0-.21,0-.36l.26-.7a.91.91,0,0,1,.51-.62c.14-.12,0,0,0-.13v0l0-.13a1,1,0,0,1,.26-.46c.28-.23.16-.4.59-.86l.27-.15,0,0,.1-.07C59.45,294.53,59.39,294.19,59.32,293.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.07,282.63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,285.73a4.41,4.41,0,0,0-.49-.48,7.29,7.29,0,0,0-.74-.49,1.74,1.74,0,0,0-.38-.14.67.67,0,0,0-.24,0,2,2,0,0,1,.41-.45,1.42,1.42,0,0,0,.53-.72l.24-.84h0c-.12.08-.24.16-.37.23l-.7.4a1.86,1.86,0,0,0-.58.57.79.79,0,0,0-.12.58c0,.15-.07.15-.07.15a1,1,0,0,0-.42.25c-.18.15-.35.29-.52.46a.5.5,0,0,0-.13.26.78.78,0,0,1-.2.43,2.3,2.3,0,0,0-.42.91c0,.12,0,.16.15.14a.34.34,0,0,0,.39.15s0,0,0,0c.25.12.37.1.6-.12a1.54,1.54,0,0,0,.17-.19c.11-.17.3-.19.48-.24a1.23,1.23,0,0,0,.59-.24s.13-.11.2,0a1.72,1.72,0,0,1,.23.32,1.41,1.41,0,0,1,.11.45,3.27,3.27,0,0,0,.17.88,1,1,0,0,0,1.1.59,1.84,1.84,0,0,1,1,0l.19.08-.36,0c-.06,0-.09,0-.12.07-.17.4-.33.8-.53,1.19a6.49,6.49,0,0,1-.46.7c-.09.15-.21.31-.11.48a.85.85,0,0,0,.67.48l.49,0a.78.78,0,0,0,.57-.42.28.28,0,0,0-.07-.27A.26.26,0,0,1,48,291a.77.77,0,0,0-.16.07c0-.11.1-.1.19-.13l0-.21-.05,0c-.11.14-.16.16-.33.11l-.13,0c-.14-.05-.17,0-.18.11a.49.49,0,0,1,0,.11.3.3,0,0,1,0-.38c.18-.23.37-.45.56-.66A7.31,7.31,0,0,0,49,288.49a.68.68,0,0,0,.1-.27.54.54,0,0,0-.26-.57,4.33,4.33,0,0,0-.69-.41.48.48,0,0,1-.29-.57l.06.19c.06.17.22.22.35.29s.45.22.66.34a.67.67,0,0,1,.22,1.07c-.12.18-.23.37-.35.56s0,.11.06.13c.39.07.77.18,1.16.22a6,6,0,0,0,1,0,10,10,0,0,0,1.73-.37,2.71,2.71,0,0,1,1-.06.09.09,0,0,0,.07,0l-.06-.54c0-.15,0-.3,0-.45a3.54,3.54,0,0,0-.36-1.47c0-.08-.1-.15-.15-.23a.84.84,0,0,1,.33.29,1.8,1.8,0,0,1,.27.73c.08.44.14.89.22,1.34a4.91,4.91,0,0,0,.4,1.39,2.52,2.52,0,0,0,.9,1c.44.27.9.51,1.37.74s.78.36,1.17.52l1.5.56.71.26a.43.43,0,0,1,.29.28l-.39-.2,0,0c0,.13.09.27.12.41.07.37.14.75.2,1.13s.1.58.14.88,0,.32,0,.49a1,1,0,0,0,.23.67l.15.14a4.68,4.68,0,0,1,.84,1,.89.89,0,0,0,.29.26h.24s0-.05,0-.06a.28.28,0,0,1,0-.37,1.28,1.28,0,0,0,.11-.27c0-.15-.08-.26-.16-.38l-.09-.12-.2.26,0,0a.44.44,0,0,0,.07-.51.85.85,0,0,0-.32-.44.78.78,0,0,1-.38-.65c0-.34-.08-.68-.12-1a4,4,0,0,1,0-.6c0-.28.06-.57.08-.85a.68.68,0,0,0-.17-.47,4.12,4.12,0,0,0-.79-.58c-.5-.35-1-.69-1.47-1.06A7,7,0,0,1,57,289.35a2.14,2.14,0,0,1-.27-.83,1.31,1.31,0,0,1,.09-.68A3.08,3.08,0,0,0,57,289c.26-.07.5-.17.54-.45a1.83,1.83,0,0,0,0-.52c0-.16.06-.25.22-.22a.82.82,0,0,1,.5.39c.39.59.77,1.19,1.16,1.79.23.36.46.73.71,1.09s.65.95,1,1.41a8.17,8.17,0,0,0,.61.71c.19.21.39.4.59.6a7.77,7.77,0,0,0,1.3,1,7.43,7.43,0,0,0,1.85.81,12.53,12.53,0,0,0,1.38.3,7.4,7.4,0,0,0,1.15.07,10.32,10.32,0,0,0,1.23-.15,7,7,0,0,0,1.82-.63c.28-.14.54-.32.81-.49,0,0,0,0,0-.05l0-.18a.47.47,0,0,0-.16,0l-.43.18a7.76,7.76,0,0,1-1.55.56,6.45,6.45,0,0,1-1.08.21,11.78,11.78,0,0,1-1.19,0,5.05,5.05,0,0,1-2-.59,6.56,6.56,0,0,1-1.38-1l-.46-.44a9.3,9.3,0,0,1-1.09-1.33,19.27,19.27,0,0,1-1.16-1.9l-.77-1.42a12.61,12.61,0,0,0-1.25-2,8.28,8.28,0,0,0-1-1.06,5.65,5.65,0,0,0-2.75-1.32,6.82,6.82,0,0,0-1-.14c-.58,0-1.16-.06-1.74-.05a9.46,9.46,0,0,0-2.48.35,6.1,6.1,0,0,0-1.45.71,3.44,3.44,0,0,1-1,.43l-.26,0a5.52,5.52,0,0,0-.58,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.31,278.1h-.39v1.1h-.22v-1.1h-.39v-.23h1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.74,277.87v1.33h-.23v-.95l-.44.68-.43-.68v.95h-.23v-1.33h.25l.41.64.42-.64Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.3,281.31v.43a3,3,0,0,0-.75-.4,2.76,2.76,0,0,0-1-.17,3.06,3.06,0,0,0-1.15.22,2.7,2.7,0,0,0-.9.61,2.54,2.54,0,0,0-.6.9,3,3,0,0,0,0,2.19,2.73,2.73,0,0,0,.6.9,2.68,2.68,0,0,0,.9.6,2.88,2.88,0,0,0,1.15.22h.11a2.94,2.94,0,0,0,1.15-.22v-1.52h0a1.57,1.57,0,0,1-.53.33,1.63,1.63,0,0,1-.62.12l-.26,0h0a1.56,1.56,0,0,1-.37-.1,1.36,1.36,0,0,1-.52-.33,1.49,1.49,0,0,1,0-2.17,1.36,1.36,0,0,1,.52-.33,1.68,1.68,0,0,1,.63-.12,1.62,1.62,0,0,1,1.15.45A1.46,1.46,0,0,1,75.3,284v2.81h1.35v-5.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.58,286.81l-3-2.89v2.89H65.23V279.2h1.35v2.87l3-2.86h1.91L67.54,283l3.95,3.81Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.16,281.17a2.53,2.53,0,0,1,1,.2,2.34,2.34,0,0,1,1.26,1.36,2.63,2.63,0,0,1,.18,1v3.1H81.26v-3.1a1.13,1.13,0,0,0-.4-.89,1.28,1.28,0,0,0-.92-.36,1.33,1.33,0,0,0-.94.36,1.19,1.19,0,0,0-.38.89v3.1H77.27v-5.49h1.35v.41a2.6,2.6,0,0,1,.69-.4A2.3,2.3,0,0,1,80.16,281.17Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.48,281.32a2.59,2.59,0,0,1,.91-.16v1.29a1.6,1.6,0,0,0-1.15.45,1.47,1.47,0,0,0-.48,1.09v2.82H96.41v-5.5h1.35v.42A3.14,3.14,0,0,1,98.48,281.32Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.44,281.17a3.15,3.15,0,0,1,1.16.22,3,3,0,0,1,1,.61,2.78,2.78,0,0,1,.64.9,2.72,2.72,0,0,1,0,2.19,2.88,2.88,0,0,1-1.59,1.5,3,3,0,0,1-1.16.22,3,3,0,0,1-1.16-.22,3,3,0,0,1-.94-.6,3,3,0,0,1-.64-.9,2.72,2.72,0,0,1,0-2.19,2.78,2.78,0,0,1,.64-.9,3,3,0,0,1,.94-.61A3.19,3.19,0,0,1,102.44,281.17Zm0,1.29a1.62,1.62,0,0,0-1.15.45,1.49,1.49,0,0,0,0,2.17,1.39,1.39,0,0,0,.53.33,1.67,1.67,0,0,0,.62.12,1.59,1.59,0,0,0,.62-.12,1.48,1.48,0,0,0,.53-.33,1.47,1.47,0,0,0,0-2.17A1.65,1.65,0,0,0,102.44,282.46Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.77,281.17a3.19,3.19,0,0,1,1.16.22,3,3,0,0,1,.94.61,2.78,2.78,0,0,1,.64.9,2.72,2.72,0,0,1,0,2.19,3,3,0,0,1-.64.9,3,3,0,0,1-.94.6,3,3,0,0,1-1.16.22,3,3,0,0,1-1.16-.22,2.88,2.88,0,0,1-1.59-1.5,2.72,2.72,0,0,1,0-2.19,2.78,2.78,0,0,1,.64-.9,3,3,0,0,1,1-.61A3.15,3.15,0,0,1,108.77,281.17Zm0,1.29a1.6,1.6,0,0,0-1.15.45,1.47,1.47,0,0,0,0,2.17,1.36,1.36,0,0,0,.52.33,1.69,1.69,0,0,0,1.25,0,1.49,1.49,0,0,0,.52-2.5A1.64,1.64,0,0,0,108.77,282.46Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.32,281.31v.43a2.88,2.88,0,0,0-.76-.4,2.72,2.72,0,0,0-1-.17,3,3,0,0,0-1.14.22,2.86,2.86,0,0,0-1.51,3.7,3.08,3.08,0,0,0,.6.9,2.83,2.83,0,0,0,.91.6,2.86,2.86,0,0,0,1.14.22h.11a3,3,0,0,0,1.16-.22v-1.52h0a1.48,1.48,0,0,1-.53.33,1.59,1.59,0,0,1-.62.12l-.26,0h0a1.61,1.61,0,0,1-.36-.1,1.39,1.39,0,0,1-.53-.33,1.49,1.49,0,0,1,0-2.17,1.39,1.39,0,0,1,.53-.33,1.67,1.67,0,0,1,.62-.12,1.6,1.6,0,0,1,1.15.45,1.43,1.43,0,0,1,.48,1.09v2.81h1.35v-5.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.77,281.31h0v.42a2.88,2.88,0,0,0-.76-.4,2.34,2.34,0,0,0-.49-.13,3.48,3.48,0,0,0-.58,0,2.94,2.94,0,0,0-1.12.22,2.72,2.72,0,0,0-.88.61,2.77,2.77,0,0,0-.57.9,3.07,3.07,0,0,0-.2,1.1h0a2.86,2.86,0,0,0,.21,1.09,3.08,3.08,0,0,0,.6.9,2.83,2.83,0,0,0,.91.6,2.86,2.86,0,0,0,1.14.22h.2a3,3,0,0,0,1.07-.22v-1.52h0a1.48,1.48,0,0,1-.53.33,1.59,1.59,0,0,1-.62.12l-.26,0h0a1.61,1.61,0,0,1-.36-.1,1.36,1.36,0,0,1-.52-.33,1.43,1.43,0,0,1-.48-1.09,1.56,1.56,0,0,1,.11-.57l0,0a1.41,1.41,0,0,1,.35-.47,1.36,1.36,0,0,1,.52-.33,1.67,1.67,0,0,1,.62-.12,1.6,1.6,0,0,1,1.15.45,1.38,1.38,0,0,1,.34.47l0,0a1.4,1.4,0,0,1,.12.58v2.14a1.43,1.43,0,0,1-.48,1.08,1.59,1.59,0,0,1-1.15.46,1.49,1.49,0,0,1-.81-.22l-1,.92a3,3,0,0,0,.84.43,3,3,0,0,0,1,.15,3,3,0,0,0,1.16-.22,3.22,3.22,0,0,0,1-.61,3,3,0,0,0,.64-.9,2.7,2.7,0,0,0,.23-1.09v-4.82H87.77Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.8,291.46v.36H65.23v-2.05h1.51v.36h-1.1v.52h.92V291h-.92v.46Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.39,289.61v2.18H69v-.09a1,1,0,0,1-.46.12.79.79,0,0,1-.8-.82.78.78,0,0,1,.8-.81.88.88,0,0,1,.46.12v-.7Zm-.4,1.71v-.64a.61.61,0,0,0-.39-.13.45.45,0,0,0-.47.45.44.44,0,0,0,.47.45A.63.63,0,0,0,69,291.32Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72,290.22v1.58h-.4v-.11a.78.78,0,0,1-.43.13c-.46,0-.67-.22-.67-.73v-.87h.4v.87c0,.25.12.37.34.37a.53.53,0,0,0,.36-.13v-1.11Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.46,291.5a.76.76,0,0,1-.61.32.82.82,0,1,1,0-1.63.75.75,0,0,1,.61.31l-.26.25a.43.43,0,0,0-.35-.2.46.46,0,1,0,0,.91.43.43,0,0,0,.35-.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77,290.22v1.58h-.4v-.12a.81.81,0,0,1-.46.14.79.79,0,0,1-.79-.82.78.78,0,0,1,.79-.81.94.94,0,0,1,.46.13v-.1Zm-.4.47a.64.64,0,0,0-.39-.14.45.45,0,0,0-.47.45.46.46,0,0,0,.47.46.58.58,0,0,0,.39-.14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.62,290.55v.56c0,.28,0,.36.25.36h.19v.3a.91.91,0,0,1-.37.06.45.45,0,0,1-.47-.5v-.77H78v-.33h.23v-.61h.4v.61h.44v.33Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80,289.84a.23.23,0,1,1,.46,0,.23.23,0,1,1-.46,0Zm0,.4h.4v1.58h-.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.21,291a.87.87,0,1,1-.86-.82A.84.84,0,0,1,83.21,291Zm-.4,0a.46.46,0,0,0-.46-.46.46.46,0,1,0,0,.91A.46.46,0,0,0,82.81,291Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.72,290.94v.88h-.4v-.88c0-.24-.12-.36-.34-.36a.5.5,0,0,0-.35.12v1.12h-.41v-1.58h.41v.1a.72.72,0,0,1,.42-.13C85.51,290.21,85.72,290.43,85.72,290.94Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.89,290.13v.73h1v.36h-1v.6h-.41v-2.05H90v.36Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.63,291a.86.86,0,1,1-.86-.82A.83.83,0,0,1,92.63,291Zm-.4,0a.46.46,0,1,0-.46.45A.46.46,0,0,0,92.23,291Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.14,290.22v1.58h-.41v-.11a.75.75,0,0,1-.43.13c-.46,0-.67-.22-.67-.73v-.87H94v.87c0,.25.12.37.35.37a.52.52,0,0,0,.35-.13v-1.11Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.72,290.94v.88h-.4v-.88c0-.24-.12-.36-.34-.36a.51.51,0,0,0-.35.12v1.12h-.4v-1.58h.4v.1a.75.75,0,0,1,.42-.13C97.51,290.21,97.72,290.43,97.72,290.94Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.39,289.61v2.18H100v-.09a1,1,0,0,1-.46.12.79.79,0,0,1-.79-.82.78.78,0,0,1,.79-.81.88.88,0,0,1,.46.12v-.7Zm-.41,1.71v-.64a.58.58,0,0,0-.38-.13.45.45,0,0,0-.47.45.44.44,0,0,0,.47.45A.58.58,0,0,0,100,291.32Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.06,290.22v1.58h-.4v-.12a.84.84,0,0,1-.47.14.78.78,0,0,1-.78-.82.77.77,0,0,1,.78-.81,1,1,0,0,1,.47.13v-.1Zm-.4.47a.64.64,0,0,0-.39-.14.46.46,0,1,0,0,.91.58.58,0,0,0,.39-.14Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.64,290.55v.56c0,.28,0,.36.25.36h.19v.3a.91.91,0,0,1-.37.06.46.46,0,0,1-.48-.5v-.77H104v-.33h.22v-.61h.41v.61h.44v.33Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.05,289.84a.23.23,0,1,1,.46,0,.23.23,0,0,1-.46,0Zm0,.4h.4v1.58h-.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.23,291a.87.87,0,1,1-.87-.82A.84.84,0,0,1,109.23,291Zm-.4,0a.47.47,0,1,0-.47.45A.47.47,0,0,0,108.83,291Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.74,290.94v.88h-.4v-.88a.32.32,0,0,0-.35-.36.47.47,0,0,0-.34.12v1.12h-.41v-1.58h.41v.1a.72.72,0,0,1,.42-.13C111.53,290.21,111.74,290.43,111.74,290.94Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 567.05,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 319.02,
    x2: 567.05,
    y2: 319.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 319.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 319.02,
    y1: 0.13,
    x2: 319.02,
    y2: 319.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 32.01,
    y1: 0.13,
    x2: 32.01,
    y2: 319.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 63.9,
    y1: 0.13,
    x2: 63.9,
    y2: 319.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 95.79,
    y1: 0.13,
    x2: 95.79,
    y2: 319.02
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.68,
    y1: 0.13,
    x2: 127.68,
    y2: 319.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 159.57,
    y1: 0.13,
    x2: 159.57,
    y2: 319.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.46,
    y1: 0.13,
    x2: 191.46,
    y2: 319.02
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 223.35,
    y1: 0.13,
    x2: 223.35,
    y2: 319.02
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 255.24,
    y1: 0.13,
    x2: 255.24,
    y2: 319.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 287.13,
    y1: 0.13,
    x2: 287.13,
    y2: 319.02
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.07,
    y1: 0.13,
    x2: 16.07,
    y2: 319.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 47.96,
    y1: 0.13,
    x2: 47.96,
    y2: 319.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 79.85,
    y1: 0.13,
    x2: 79.85,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.74,
    y1: 0.13,
    x2: 111.74,
    y2: 319.02
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.63,
    y1: 0.13,
    x2: 143.63,
    y2: 319.02
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 175.52,
    y1: 0.13,
    x2: 175.52,
    y2: 319.02
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 207.41,
    y1: 0.13,
    x2: 207.41,
    y2: 319.02
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 239.3,
    y1: 0.13,
    x2: 239.3,
    y2: 319.02
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 271.19,
    y1: 0.13,
    x2: 271.19,
    y2: 319.02
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 303.08,
    y1: 0.13,
    x2: 303.08,
    y2: 319.02
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 287.13,
    x2: 567.05,
    y2: 287.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 255.24,
    x2: 567.05,
    y2: 255.24
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 223.35,
    x2: 567.05,
    y2: 223.35
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 191.46,
    x2: 567.05,
    y2: 191.46
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 159.57,
    x2: 567.05,
    y2: 159.57
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 127.68,
    x2: 567.05,
    y2: 127.68
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 95.79,
    x2: 567.05,
    y2: 95.79
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 63.9,
    x2: 567.05,
    y2: 63.9
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 32.01,
    x2: 567.05,
    y2: 32.01
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 303.08,
    x2: 567.05,
    y2: 303.08
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 271.19,
    x2: 567.05,
    y2: 271.19
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 239.3,
    x2: 567.05,
    y2: 239.3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 207.41,
    x2: 567.05,
    y2: 207.41
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 175.52,
    x2: 567.05,
    y2: 175.52
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 143.63,
    x2: 567.05,
    y2: 143.63
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 111.74,
    x2: 567.05,
    y2: 111.74
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 79.85,
    x2: 567.05,
    y2: 79.85
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 47.96,
    x2: 567.05,
    y2: 47.96
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 16.07,
    x2: 567.05,
    y2: 16.07
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 350.91,
    y1: 0.13,
    x2: 350.91,
    y2: 319.02
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 382.8,
    y1: 0.13,
    x2: 382.8,
    y2: 319.02
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 414.69,
    y1: 0.13,
    x2: 414.69,
    y2: 319.02
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 446.58,
    y1: 0.13,
    x2: 446.58,
    y2: 319.02
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 478.47,
    y1: 0.2,
    x2: 478.47,
    y2: 319.09
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 334.97,
    y1: 0.13,
    x2: 334.97,
    y2: 319.02
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 366.86,
    y1: 0.13,
    x2: 366.86,
    y2: 319.02
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 398.75,
    y1: 0.13,
    x2: 398.75,
    y2: 319.02
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 430.64,
    y1: 0.13,
    x2: 430.64,
    y2: 319.02
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 462.53,
    y1: 0.13,
    x2: 462.53,
    y2: 319.02
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 510.36,
    y1: 0.13,
    x2: 510.36,
    y2: 319.02
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 542.25,
    y1: 0.13,
    x2: 542.25,
    y2: 319.02
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 494.42,
    y1: 0.13,
    x2: 494.42,
    y2: 319.02
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 526.31,
    y1: 0.13,
    x2: 526.31,
    y2: 319.02
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 558.2,
    y1: 0.13,
    x2: 558.2,
    y2: 319.02
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.49,335.41l.3-.34a2.19,2.19,0,0,0,1.67.77c1.09,0,1.4-.6,1.4-1.06,0-1.57-3.2-.75-3.2-2.61,0-.88.78-1.43,1.75-1.43a2.31,2.31,0,0,1,1.81.75l-.3.34a1.93,1.93,0,0,0-1.53-.67c-.71,0-1.25.41-1.25,1,0,1.37,3.2.62,3.2,2.61,0,.69-.46,1.51-1.9,1.51A2.47,2.47,0,0,1,.49,335.41Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.31,331.37a.32.32,0,1,1,.32.32A.32.32,0,0,1,5.31,331.37Zm.11,4.79V332.3h.42v3.86Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.93,336.16v-.34l2.29-3.15H6.93v-.37H9.76v.34l-2.32,3.15H9.79v.37Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.67,334.23a1.92,1.92,0,0,1,1.85-2,1.85,1.85,0,0,1,1.83,2.05v.11H11.12a1.51,1.51,0,0,0,1.51,1.54,1.7,1.7,0,0,0,1.26-.54l.22.27a2,2,0,0,1-1.51.63A1.9,1.9,0,0,1,10.67,334.23Zm1.85-1.67a1.45,1.45,0,0,0-1.4,1.48h2.8A1.41,1.41,0,0,0,12.52,332.56Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.29,332.6a.36.36,0,0,1,.36-.36.36.36,0,0,1,.35.36.35.35,0,0,1-.35.34A.36.36,0,0,1,15.29,332.6Zm0,3.28a.36.36,0,0,1,.36-.34.35.35,0,1,1,0,.69A.36.36,0,0,1,15.29,335.88Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.92,336.16v-4.71l-.85.91-.28-.29L20,330.83h.42v5.33Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.51,333.5c0-1.37.57-2.75,2-2.75a1.72,1.72,0,0,1,1.44.68l-.27.33a1.33,1.33,0,0,0-1.17-.59c-1.15,0-1.58,1.2-1.58,2.34a2.09,2.09,0,0,0,0,.25,2,2,0,0,1,1.56-.89,1.58,1.58,0,0,1,1.72,1.69,1.7,1.7,0,0,1-1.79,1.7C22,336.26,21.51,334.93,21.51,333.5Zm3.28,1.06a1.2,1.2,0,0,0-1.33-1.28,1.75,1.75,0,0,0-1.46.91c.07.73.45,1.65,1.45,1.65A1.28,1.28,0,0,0,24.79,334.56Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.24,332.6a.36.36,0,1,1,.71,0,.36.36,0,0,1-.71,0Zm0,3.28a.36.36,0,1,1,.36.35A.35.35,0,0,1,26.24,335.88Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.18,335.57l.27-.33a1.35,1.35,0,0,0,1.17.6c1.17,0,1.57-1.23,1.57-2.35v-.25a2,2,0,0,1-1.56.89,1.58,1.58,0,0,1-1.72-1.69,1.7,1.7,0,0,1,1.79-1.7c1.44,0,2,1.33,2,2.76s-.57,2.75-2,2.75A1.7,1.7,0,0,1,28.18,335.57Zm3-2.76c-.06-.72-.44-1.65-1.44-1.65a1.28,1.28,0,0,0-1.35,1.28,1.21,1.21,0,0,0,1.34,1.28A1.72,1.72,0,0,0,31.16,332.81Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 318.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial9);
export default __webpack_public_path__ + "static/media/guideMaterial9.c95c69161869dbd586aca31750470f11.svg";
export { ForwardRef as ReactComponent };